module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mybg-wrap"
  }, [_c('cIndex'), _vm._v(" "), _c('div', {
    staticClass: "mybaogao"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNull),
      expression: "isNull"
    }],
    staticClass: "null-list"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/04.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无检测报告数据")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("造成没有检测报告的原因可能是：")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("1.未填写正确的身份证号,无法关联查询出检测报告 ; "), _c('router-link', {
    attrs: {
      "to": "/setinfo",
      "tag": "i"
    }
  }, [_vm._v("立即完善")])], 1), _vm._v(" "), _c('li', [_vm._v("2.还没有进行过脑能力检测 ; "), _c('router-link', {
    attrs: {
      "to": {
        path: '/payment',
        query: {
          pID: 1
        }
      },
      "tag": "i"
    }
  }, [_vm._v("立即检测")])], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isList),
      expression: "isList"
    }],
    staticClass: "baogao-list"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.getReportList), function(item, index) {
    return _c('tr', [_c('td', {
      staticClass: "box"
    }), _vm._v(" "), _c('td', {
      staticClass: "box"
    }), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', {
      staticClass: "box"
    }), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(item.username))])]), _vm._v(" "), _c('td', {
      staticClass: "box"
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.rezhi))]), _vm._v(" "), _c('td', {
      staticClass: "box"
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cpTime))]), _vm._v(" "), _c('td', {
      staticClass: "box"
    }), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.tc))]), _vm._v(" "), _c('td', {
      staticClass: "box"
    }), _vm._v(" "), _c('td', {
      staticClass: "lookReport",
      on: {
        "click": function($event) {
          _vm.lookREport(item.id, item.packageid, item.bid)
        }
      }
    }, [_vm._v("查看")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('span', {
    staticClass: "el-pagination__total"
  }, [_vm._v("共 "), _c('span', [_vm._v(_vm._s(_vm.getPages))]), _vm._v(" 页")]), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "page-size": _vm.pageSize,
      "total": _vm.getTotal,
      "layout": "prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    }
  }, [_vm._v("确定")])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "box"
  }), _vm._v(" "), _c('th', {
    staticClass: "box"
  }), _vm._v(" "), _c('th', [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticClass: "box"
  }), _vm._v(" "), _c('th', [_vm._v("检测人")]), _vm._v(" "), _c('th', {
    staticClass: "box"
  }), _vm._v(" "), _c('th', [_vm._v("检测结果")]), _vm._v(" "), _c('th', {
    staticClass: "box"
  }), _vm._v(" "), _c('th', [_vm._v("检测时间")]), _vm._v(" "), _c('th', {
    staticClass: "box"
  }), _vm._v(" "), _c('th', [_vm._v("检测套餐")]), _vm._v(" "), _c('th', {
    staticClass: "box"
  }), _vm._v(" "), _c('th', {
    staticClass: "update-right"
  }, [_vm._v("操作")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a1543db","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mybaogao.vue
// module id = 761
// module chunks = 1